import { InjectionToken, signal, WritableSignal } from '@angular/core';

// null means no initialization error; an empty fragment represents a generic error.
export const AUTH_INITIALIZATION_ERROR = new InjectionToken<
  WritableSignal<string | null>
>('AUTH_INITIALIZATION_ERROR', {
  providedIn: 'root',
  factory: () => signal<string | null>(null),
});
